import React from "react";

const IMAGE_ICON = (
  <path
    d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);

const VIDEO_ICON = (
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
  />
);

export default function MediaUpload({
  type = "image",
  inputId,
  accept,
  hint,
  uploadLabel,
  onSelect,
  onRemove,
  preview,
}) {
  const isImage = type === "image";

  if (preview) {
    return (
      <div className="relative inline-block min-w-0">
        {isImage ? (
          <img
            src={preview}
            alt="Preview"
            className="max-w-full md:max-w-md h-auto rounded-lg border border-gray-300"
          />
        ) : (
          <video
            src={preview}
            controls
            className="max-w-full md:max-w-md h-auto rounded-lg border border-gray-300 text-xs md:text-sm">
            Your browser does not support the video tag.
          </video>
        )}
        <button
          type="button"
          onClick={onRemove}
          className="absolute top-2 right-2 bg-red-600 text-white text-xs md:text-sm px-3 py-1.5 rounded-lg hover:bg-red-700 font-medium shadow-md transition-colors">
          Remove
        </button>
      </div>
    );
  }

  return (
    <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 sm:p-8 text-center hover:border-red-400 transition-colors cursor-pointer min-w-0">
      <input
        type="file"
        accept={accept}
        onChange={onSelect}
        className="hidden"
        id={inputId}
      />
      <label htmlFor={inputId} className="cursor-pointer block">
        <svg
          className="mx-auto h-10 w-10 sm:h-12 sm:w-12 text-gray-400"
          stroke="currentColor"
          fill="none"
          viewBox={isImage ? "0 0 48 48" : "0 0 24 24"}
          aria-hidden>
          {isImage ? IMAGE_ICON : VIDEO_ICON}
        </svg>
        <div className="mt-4 flex flex-wrap text-xs md:text-sm leading-6 text-gray-600 justify-center gap-1">
          <span className="relative cursor-pointer rounded-md font-semibold text-red-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-red-600 focus-within:ring-offset-2 hover:text-red-500">
            {uploadLabel}
          </span>
          <span>or drag and drop</span>
        </div>
        <p className="text-xs leading-5 text-gray-600 mt-2">{hint}</p>
      </label>
    </div>
  );
}
